import type { Command } from "./types.ts";

/** A tiny registry that maps names + aliases to commands. */
export class CommandRegistry {
  private byName = new Map<string, Command>();
  private order: Command[] = [];

  register(cmd: Command): void {
    this.order.push(cmd);
    this.byName.set(cmd.name.toLowerCase(), cmd);
    for (const a of cmd.aliases ?? []) {
      this.byName.set(a.toLowerCase(), cmd);
    }
  }

  registerAll(cmds: Command[]): void {
    for (const c of cmds) this.register(c);
  }

  get(name: string): Command | undefined {
    return this.byName.get(name.toLowerCase());
  }

  /** Visible commands, in registration order. */
  list(): Command[] {
    return this.order.filter((c) => !c.hidden);
  }

  /** All command + alias names, for tab completion. */
  names(): string[] {
    return [...this.byName.keys()];
  }
}
